import { buildHref, matchRoute } from "@softmax/web-addresses";
import type { WikiPageTarget } from "@softmax/web-ux/wiki";

export function communityNavigation({
  basePath,
  navigationSearch = "",
}: {
  basePath: string;
  navigationSearch?: string;
}) {
  const route = matchRoute(basePath);

  if (
    route.area !== "game" &&
    route.name !== "forum" &&
    route.name !== "wiki" &&
    route.name !== "admin.forum" &&
    route.name !== "admin.wiki"
  )
    throw new Error(`Invalid community location: ${basePath}`);

  const search = new URLSearchParams(navigationSearch);

  return {
    forumHref({ postId }: { postId?: string } = {}) {
      if (route.area === "game") {
        const game = {
          slug: route.gameSlug,
          catalog_status: route.catalogScope,
        };
        return postId
          ? buildHref({ name: "game.forumPost", game, postId, search })
          : buildHref({ name: "game.forum", game, search });
      }

      if (route.name === "admin.forum" || route.name === "admin.wiki")
        return postId
          ? buildHref({
              name: "admin.forumPost",
              slug: route.slug,
              postId,
              search,
            })
          : buildHref({ name: "admin.forum", slug: route.slug, search });

      return postId
        ? buildHref({ name: "forumPost", postId, search })
        : buildHref({ name: "forum", search });
    },
    wikiPageHref(target: WikiPageTarget) {
      let page: readonly string[];
      let query = search;
      let hash: string | undefined;

      if ("pageSlug" in target) {
        page = target.pageSlug.split("/");
      } else {
        const relative = new URL(target.relativeHref, "https://wiki.invalid/");
        const linked = matchRoute(`/wiki${relative.pathname}`);

        if (linked.name !== "wikiPage")
          throw new Error(`Invalid wiki link: ${target.relativeHref}`);

        page = linked.page;
        query = new URLSearchParams(relative.search);

        for (const key of new Set(search.keys())) query.delete(key);

        for (const [key, value] of search) query.append(key, value);

        hash = relative.hash;
      }

      if (route.area === "game") {
        const game = {
          slug: route.gameSlug,
          catalog_status: route.catalogScope,
        };
        return buildHref({
          name: "game.wikiPage",
          game,
          page,
          search: query,
          hash,
        });
      }

      if (route.name === "admin.forum" || route.name === "admin.wiki")
        return buildHref({
          name: "admin.wiki",
          slug: route.slug,
          page,
          search: query,
          hash,
        });

      return buildHref({ name: "wikiPage", page, search: query, hash });
    },
  };
}
